import * as React from 'react'
import { List, Map } from 'immutable'
import { any, Action, async, mk_widget, IOWidget } from 'widgets-for-react'
import {
  FormData,
  FormState,
  DependenciesState,
  FieldId,
  DependencyResult,
  FieldData,
  DependencyId,
  IsMet
} from './types'
import { initializeIcons } from '@uifabric/icons'
import { Fabric } from 'office-ui-fabric-react/lib/Fabric'
import { formRenderer } from './renderers'
import { get_dependency_result } from './utils'
import { AsyncMonitor } from './async_monitor'
import { fromJSX } from '../../utils'
// import { Loader } from '../public_site/templates/loader.mod'
// import { fromJSX } from '../public_site/utils/utils'
// import { datalayerHandler } from '../cms/blocks/utils/gtm.mod'

initializeIcons()

export let formWidget: IOWidget<FormState, Action<FormState>> = (s0) => {
  let dependencies_async_list = List<{
    dep_res: { kind: 'async'; value: AsyncMonitor<IsMet> }
    dep_id: DependencyId
    field_id: FieldId
  }>()
  s0.dependencies_state.forEach((field_id__dep_res, dep_id) => {
    field_id__dep_res.forEach((dep_res, field_id) => {
      if (dep_res.kind == 'async') dependencies_async_list = dependencies_async_list.push({ dep_id, field_id, dep_res })
    })
  })
  return any<Action<FormState>>()(
    //we load the async dependencies
    dependencies_async_list
      .map((dep_elem, index) => {
        return dep_elem.dep_res.value.Widget.map<Action<FormState>>((a) => (s) => {
          let s1 = s
          let a1 = a
          let field_id__dep_res = s.dependencies_state
            .get(dep_elem.dep_id)
            .set(dep_elem.field_id, { kind: 'async', value: a1 })
          return { ...s1, dependencies_state: s1.dependencies_state.set(dep_elem.dep_id, field_id__dep_res) }
        })
      })
      .toArray()
      .concat([
        //we load the form
        async<FormData>()(s0.form_data).map<Action<FormState>>((a) => (state) => {
          let a1 = a(state.form_data)
          let new_state = { ...state, form_data: a1 }
          if (new_state.form_data.kind == 'loaded') {
            let all_fields: Map<FieldId, FieldData> = Map<FieldId, FieldData>()
            new_state.form_data.value.steps.forEach((s) => {
              s.fields.forEach((f) => {
                all_fields = all_fields.set(f.Id, f)
              })
            })
            let dependenciesState: DependenciesState = Map()
            new_state.form_data.value.steps.forEach((s) => {
              s.dependencies.forEach((d) => {
                let dependent_fields = Map<FieldId, DependencyResult>()
                d.dependent_fields.forEach((f) => {
                  if (all_fields.has(f.FieldId)) {
                    let field_dep_state = dependent_fields.get(f.FieldId)
                    let dependency_result = get_dependency_result(
                      f.FieldId,
                      all_fields.get(f.FieldId).user_input,
                      d.dependency,
                      field_dep_state && field_dep_state.kind == 'async' ? field_dep_state.value : undefined
                    )
                    if (dependency_result.kind == 'simple' && dependency_result.value == false) {
                      dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
                    } else {
                      if (dependency_result.kind == 'async') {
                        if (
                          dependency_result.value.Result.kind == 'loaded' &&
                          dependency_result.value.Result.value == false
                        )
                          dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
                        else {
                          if (dependency_result.value.Result.kind != 'unloaded') {
                            dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
                          }
                        }
                      }
                    }
                  }
                })
                dependenciesState = dependenciesState.set(d.dependency.Id, dependent_fields)
              })
            })
            new_state.dependencies_state = dependenciesState
          }
          return new_state
        }),
        async<string>(null, {
          key: 'submission form async',
          connectionError: fromJSX(() => <p className='form__alert alert--error'>Probleem met verbinden. Probeer het later opnieuw</p>).never(),
          loading: (state) => fromJSX(() => <p className='form__alert alert--info'>Formulier wordt verzonden...</p>).never(),
          unauthorizedError: fromJSX(() => <p className='form__alert alert--error'>Geen toegang.</p>).never(),
          otherError: fromJSX(() => <p className='form__alert alert--error'>Er is iets fout gegaan. Probeer het later opnieuw.</p>).never(),
          unloaded: null
        })(s0.form_submission_logic).map<Action<FormState>>((a) => (s) => {
          let a1 = a(s.form_submission_logic)
          if (s.form_submission_logic.kind === 'loading' && a1.kind === 'loaded') {
            // let s1 : FormState =  undefined
            // if(s.alternative_get_api){
            //   s1 = s.alternative_get_api([], s.form_data.kind === 'loaded' ? s.form_data.value.form.Id.toString() : '')

            // }
            // else{

            //   s1 = getFormState([], s.form_data.kind === 'loaded' ? s.form_data.value.form.Id.toString() : '')
            // }
            return {
              ...s,
              form_submission_logic: a1,
              context: s.context
            }
          }
          return { ...s, form_submission_logic: a1 }
        }),

        mk_widget({
          run: (set_state) => {
            if (s0.form_data.kind != 'loaded') return  <div className="loader"><div className="loader__inner"></div></div>
            return formRenderer(
              s0.form_data.value,
              s0,
              (new_form_submission_logic) =>
                set_state((s) => ({ ...s, form_submission_logic: new_form_submission_logic })),
              (new_form, new_dependencies) =>
                set_state((s) => {
                  if (s.form_data.kind != 'loaded') return s
                  if (s.form_started == false) {
                    // window._mtm.push({
                    //   event: `event.${window.site.Name}`, category: s.form_data.value.form.title, action: "Start form", label: window.location.pathname
                    // })
                    // if (window.location.href.includes('opdrachten/id')) {
                    //   datalayerHandler('vacancies', 'start_application', 'vacancies')
                    // } else {
                    //   datalayerHandler('contact', 'start', 'contact')
                    // }
                  }
                  return {
                    ...s,
                    form_data: { ...s.form_data, value: new_form },
                    dependencies_state: new_dependencies,
                    form_started: true
                  }
                })
            )
          }
        })
      ])
  ).wrapHTML((jsx) => (
    <Fabric id='io-formstack' className='block__wrapper'>
      {jsx}
    </Fabric>
  ))
}
